// extracted by mini-css-extract-plugin
module.exports = {"calendarDetailsContainer":"styles_calendarDetailsContainer__2yZmx","publishingsContent":"styles_publishingsContent__1ZlKL"};